/**
* Created by vouill on 4/22/18.
*/

<template>
  <div>
    <div class="v-title">
      <img
        v-if="authorPicture"
        :src="authorPicture.file.url" >
      <div>
        {{ author.lastname }} {{ author.firstname }}
      </div>
    </div>
    <div class="v-content">{{ author.description }}</div>
  </div>
</template>

<style scoped>
.v-title {
  display: flex;
  align-items: center;
  font-size: 30px;
  margin-bottom: 1em;
  font-weight: 600;
}
img {
  width: 100px;
  margin-right: 2em;
}
</style>


<script>
import { getAsset } from "../../utils/contentful";

export default {
  name: "Author",
  props: {
    author: {
      type: Object
    },
    includes: {
      type: Object
    }
  },
  computed: {
    authorPicture() {
      return (
        this.author.authorPicture &&
        getAsset(this.includes, this.author.authorPicture.sys.id).fields
      );
    }
  }
};
</script>
